/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // disabled: true,
    // badge: {
    //     title: "Tamamlanmadı",
    //     classes: 'px-2 ml-2 bg-pink-600 text-white rounded-full'
    // },

    {
        id: 'general',

        title: 'Hızlı Erişim',
        type: 'group',
        icon: 'mat_outline:construction',
        subtitle: 'Hızlı Erişim',

        children: [
            {
                id: 'analysis',
                title: 'Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: 'analysis',
            },
            {
                id: 'users',
                title: 'Kullanıcılar',
                type: 'basic',
                icon: 'mat_outline:person',
                link: 'users',
            },

            {
                id: 'categories',
                title: 'Kategoriler',
                type: 'basic',
                icon: 'mat_outline:category',
                link: 'categories',
            },

            {
                id: 'words',
                title: 'Kelimeler',
                type: 'basic',
                icon: 'mat_outline:book',
                link: 'words',
            },

            {
                id: 'notifications',
                title: 'Bildirimler',
                type: 'basic',
                icon: 'mat_outline:notifications',
                link: 'notifications',
            },

            {
                id: 'badges',
                title: 'Rozetler',
                type: 'basic',
                icon: 'mat_outline:star',
                link: 'badges',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
